import { Card, CardText } from 'material-ui';
import React, { useEffect, useState } from 'react';

async function getHTML(cb) {
  try {
    const res = await fetch(
      'https://statics.pinchos.se/web/site/orders.pinchos.se/sv/pn-contact.json',
    );
    const data = await res.json();
    cb(data.blocks[0]);
    return data;
  } catch (error) {
    console.error(error);
    cb(null);
    return null;
  }
}

export default function ContactList() {
  const [html, setHtml] = useState(null);
  useEffect(() => {
    getHTML(setHtml);
  }, []);

  if (!html) {
    return null;
  }

  return (
    <Card>
      <CardText
        style={{ padding: '16px' }}
        dangerouslySetInnerHTML={{ __html: html.text }}
      />
    </Card>
  );
}
